import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Table } from 'primeng/table';
import { ConfirmationService, MenuItem, SelectItem } from 'primeng/api';
import { SaidaEstoqueService } from 'src/app/admihair/service/saida-estoque.service';
import { SaidaEstoque } from 'src/app/admihair/api/dto/saida-estoque';
import { DiaMes } from 'src/app/admihair/api/dto/datas/dia-mes';

@Component({
  selector: 'app-saida-estoque-listar',
  templateUrl: './saida-estoque-listar.component.html',
  styleUrls: ['./saida-estoque-listar.component.scss']
})
export class SaidaEstoqueListarComponent extends AdmihairBaseComponent implements OnInit {

  permissaoInserirIdentificada: boolean = false;
  loadingTable: boolean = false;
  saidasEstoque: SaidaEstoque[] = [];
  dataFiltroPadrao: Date = new Date();
  diasComSaidas: SelectItem[] = [];
  diaSaidaSelecionado?: Date;

  itemsMenuBotao: MenuItem[] = [
    {
      label: 'Saída Normal', icon: 'pi pi-calendar-minus',
      command: () => this.redirecionarSaidaNormal()
    },
    {
      label: 'Saída Identificada', icon: 'pi pi-calendar-plus',
      command: () => this.redirecionarSaidaIdentificada()
    }];

  @ViewChild('filter') filter!: ElementRef;
  filtroDataTransacao?: Date;

  constructor(private saidaEstoqueService: SaidaEstoqueService,
    private confirmationService: ConfirmationService,
    erroService: ErroService,
    storageService: UtilStorageService,
    router: Router,
    activatedRoute: ActivatedRoute) {
    super(erroService, storageService, router, activatedRoute)
  }

  ngOnInit(): void {
    this.setExibirSpinnerPrincipal(true);
    this.verificarPermissoes();
    if (this.permissaoListar) {
      this.carregarSaidasEstoque();
    }
  }



  redirecionarSaidaNormal() {
    this.redirecionarPagina('inserir')
  }
  redirecionarSaidaIdentificada() {
    this.redirecionarPagina('inserir-identificada')
  }

  carregarSaidasEstoque() {
    this.loadingTable = true;
    const filtroCompetencia = this.diaSaidaSelecionado ? new Date(this.diaSaidaSelecionado) : this.dataFiltroPadrao;
    this.saidaEstoqueService.listarPorEmpresaIdEPorData(this.getEmpresa().id, filtroCompetencia).subscribe({
      next: (data: SaidaEstoque[]) => {
        this.saidasEstoque = data;
        this.loadingTable = false;
      },
      error: (err: any) => {
        this.loadingTable = false;
        this.exibirMensagemErro(err);
      }
    })

  }


  excluir(id: number) {
    this.confirmationService.confirm({
      message: 'Tem certeza que seja excluir?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.saidaEstoqueService.excluir(id).subscribe({
          next: () => {
            this.carregarSaidasEstoque();
            this.exibirMensagemSucesso();
          },
          error: (err: any) => {
            this.exibirMensagemErro(err);
          }
        })

      }
    });
  }


  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

  buscarDiasComRegistro() {
    if(this.filtroDataTransacao?.getMonth() !== this.dataFiltroPadrao.getMonth()) {
      this.saidasEstoque = [];
    }
    this.saidaEstoqueService.listarDiasComSaidasPorEmpresaIdECompetencia(this.getEmpresa().id,
      this.filtroDataTransacao).subscribe({
        next: (data: DiaMes[]) => {
          this.diasComSaidas = data.map(item => ({label: item.dia, value: item.data}));
        },
        error: (err: any) => {
          this.exibirMensagemErro(err);
        }

      })
  }

  verificarPermissoes() {
    this.permissaoListar = this.verificarPermissao('PERM_LISTAR_SAIDA_ESTOQUE');
    this.permissaoInserir = this.verificarPermissao('PERM_INSERIR_SAIDA_ESTOQUE');
    this.permissaoInserirIdentificada = this.verificarPermissao('PERM_INSERIR_SAIDA_ESTOQUE_IDENTIFICADA');
    this.permissaoExcluir = this.verificarPermissao('PERM_EXCLUIR_SAIDA_ESTOQUE');
  }

}
